import React from 'react'
import { InferGetServerSidePropsType } from 'next'
import { fetchNationalStaticData } from '@scentregroup/shared/hub-components/universal-header'
import { localeToCountry } from '@scentregroup/shared/helpers/local-to-country'
import { getDefaultNationalMetaData } from '@scentregroup/shared/helpers/get-default-national-metadata'
import { setCacheHeaders } from '@scentregroup/shared/helpers/set-cache-headers'
import { GetServerSideProps, GetServerSidePropsContext } from '../types/next'
import { makeApolloClient } from '../lib/apolloClient'
import { propsOrNotFound } from '../lib/props-or-not-found'
import { getContentPage } from '../lib/get-content-detail/content-page'
import Layout from '../../../src/shared/hub-components/layout'
import Content from '../components/page-templates/content-detail/content-page'

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  res,
}: GetServerSidePropsContext) => {
  setCacheHeaders(res)
  const client = makeApolloClient()
  const country = localeToCountry(locale)

  const [withContentPageProps, nationalHeaderData] = await Promise.all([
    getContentPage(client, country, 'terms-and-conditions'),
    fetchNationalStaticData(client, { country }),
  ])
  const data = await getContentPage(client, country, 'terms-and-conditions')

  return propsOrNotFound({
    props: {
      nationalHeaderData,
      content: withContentPageProps,
      country,
      data,
    },
  })
}

const TermsAndConditionsPage = ({
  nationalHeaderData,
  country,
  content,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const metaData = getDefaultNationalMetaData({
    country,
    type: 'terms-and-conditions',
  })

  return (
    <Layout
      country={country}
      header={{
        variant: 'national',
        data: nationalHeaderData,
      }}
      metaData={metaData}
    >
      <Content modules={content.modules} title={content.metaData.title} />
    </Layout>
  )
}

export default TermsAndConditionsPage
